export default __webpack_public_path__ + "static/media/support-mobile-mx.3dfa23ac.svg";